/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { CustomStudyDraftInfoValues } from './customStudyDraftInfoModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'custom-study-draft-info-modal',
    standalone: false,
})
export class CustomStudyDraftInfoModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Input() resolve: CustomStudyDraftInfoValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('customStudyDraftInfoModal', elementRef, injector);
    }
}
